import type { JSXElementConstructor, ReactNode } from 'react'

type ProviderProps = { children: ReactNode }

export function composeProviders(
	...providers: Array<JSXElementConstructor<ProviderProps>>
): JSXElementConstructor<ProviderProps> {
	return providers.reduce(
		(AccumulatedProviders, CurrentProvider) => {
			return function CombinedProvider({ children }: ProviderProps) {
				return (
					<AccumulatedProviders>
						<CurrentProvider>{children}</CurrentProvider>
					</AccumulatedProviders>
				)
			}
		},
		function BaseProvider({ children }: ProviderProps) {
			return children as JSX.Element
		}
	)
}
